module.exports = __webpack_public_path__ + "img/horizontal_3_3_8011.1bc875ff.png";